import { memo } from "react";
import { config,requestLogout } from "../../constants/constant";
import { withRouter, NavLink } from "react-router-dom";
import Header from "./Header";
import { useContext } from "react";
import { AuthContext } from "../../Providers/ContextProviders/AuthContext";
import AsPieProgress2 from "../util/AsPieProgress2";

const Navbar = (props) => {
  const { isLoggedIn } = useContext(AuthContext);
  const routeArray = [
    "/setup-enterprise",
    "/developer/setup-user",
    "/signup-success",
    "/developer/mobile-verification",
    "/developer/review-details",
  ];
  const activeArray = [
    "/developer/dashboard",
    "/developer/my-brands",
    "/developer/launch/",
    "/developer/my-carriers",
    "/billing/",
    "/developer/price",
    "/developer/api",
    "/developer/create-bot/whatsapp-bot-details",
    "/developer/create-bot/rcs-bot-details",
    "/developer/create-bot/brand-details",
    "/developer/create-bot/select-carriers",
    "/developer/listing",
    "/developer/bot-console",
    "/developer/launch-details",
    "/developer/view-bot-details/whatsapp/", //14
    "/developer/update-whatsapp-bot/", //15
    "/developer/add-view-template/",
    "/developer/view-template-details",
    "/developer/update-brand",
    /my-campaigns/,
    /add-new-campaign/,
    /my-billing/,
    "/developer/addTemplate",
    "/analytics/campaign-engagement-dashboard", //23
    /traffic-dashboard/,
    "/developer-assets"
  ];
  const AnalyticsToDevelopers = (ExtendedPath) => {
    window.location.href = config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI + ExtendedPath;
  }
  // console.log(activeArray[21].test(props.location.pathname),"Hello Props")

  return (
    <>
      {!props.isDataPresent ? (
        <nav className="navbar navbar-default navbar-fixed-top navbar-bg">
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#bs-example-navbar-collapse-1"
                aria-expanded="false"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              {!isLoggedIn ? (
                <a className="navbar-brand" href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/`}>
                  <img
                    src="images/dotgo_logo_white.svg"
                    width={95}
                    alt="Dotgo"
                  />
                </a>
              ) : (
                <a className="navbar-brand" href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/`}>
                <img
                  src="images/dotgo_logo_white.svg"
                  width={95}
                  alt="Dotgo"
                />
                </a>
              )}
            </div>
            {/* TODO: conditions refactor */}
            <div
              className="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
            >
              <ul className="nav navbar-nav   navbar-left">

              {props.partnerDetails.isAggregator === true &&
                props.partnerDetails.launchApproved === false ? (
                  <li>
                    <NavLink className="ol-nav-link" to="/analytics/my-billing">
                      MY BILLING
                    </NavLink>
                    {/* </a> */}
                  </li>
                ) : (
                  <li
                    className={
                      activeArray[21].test(props.location.pathname)
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink className="ol-nav-link" to="/analytics/my-billing">
                      MY BILLING
                    </NavLink>
                  </li>
                )}

                <li
                  className={
                    (props.location.pathname === activeArray[0] && "active") ||
                    (props.location.pathname === activeArray[7] && "active") ||
                    (props.location.pathname === activeArray[8] && "active") ||
                    (props.location.pathname === activeArray[9] && "active") ||
                    (props.location.pathname === activeArray[10] && "active") ||
                    (props.location.pathname.includes(activeArray[11]) &&
                      "active") ||
                    (props.location.pathname.includes(activeArray[12]) &&
                      "active") ||
                    (props.location.pathname.includes(activeArray[13]) &&
                      "active") ||
                    (props.location.pathname.includes(activeArray[14]) &&
                      "active") ||
                    (props.location.pathname.includes(activeArray[15]) &&
                      "active") ||
                    (props.location.pathname.includes(activeArray[16]) &&
                      "active") ||
                      (props.location.pathname.includes(activeArray[17]) &&
                        "active")||
                        (props.location.pathname.includes(activeArray[22]) &&
                          "active")
                  }
                >
                  <a
                    href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/dashboard`}
                    className="ol-nav-link"
                  >
                      MY BOTS
                  </a>
                </li>

                {props.partnerDetails.isAggregator === true &&
                props.partnerDetails.launchApproved === false ? (
                  <li
                  >
                    <a
                                  style={{ cursor: "not-allowed" }}
                      href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/my-brands`}
                      className="ol-nav-link"
                    >
                        MY BRANDS
                    </a>
                  </li>
                ) : (
                  <li
                    className={
                      (props.location.pathname.includes(activeArray[1]) &&
                        "active") ||
                      (props.location.pathname.includes(activeArray[18]) &&
                        "active")
                    }
                  >
                    <a
                      href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/my-brands`}
                      className="ol-nav-link"
                    >
                        MY BRANDS
                    </a>
                  </li>
                )}

                <li
                  className={
                    (props.location.pathname.includes(activeArray[3]) &&
                      "active")
                  }
                >
                  <a
                    href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/my-carriers`}
                    className="ol-nav-link"
                  >
                      PRICING
                  </a>
                </li>

                <li
                  className={
                    props.location.pathname === activeArray[6] && "active"
                  }
                >
                  <a
                    href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/api`}
                    className="ol-nav-link"
                  >
                      API
                  </a>
                </li>

                {props.partnerDetails.isAggregator === true &&
                props.partnerDetails.launchApproved === false ? (
                  <li>
                      <a
                      style={{
                      cursor: "not-allowed",
                      pointerEvents: "painted",
                    }}
          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/my-campaigns`}
          className="ol-nav-link"
        >
          MY CAMPAIGNS
        </a>
                  </li>
                ) : (
                  <li
                    className={
                      (activeArray[19].test(props.location.pathname) &&
                        "active") ||
                      (activeArray[20].test(props.location.pathname) &&
                        "active") 
                        ||
                      ("/analytics/campaign-engagement-dashboard" === props.location.pathname &&
                        "active")
                    }
                  >
                    {/* <NavLink
                      className="ol-nav-link"
                      to="/developer/my-campaigns"
                    >
                      MY CAMPAIGNS
                    </NavLink> */}
                      <a
          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/my-campaigns`}
          className="ol-nav-link"
        >
          MY CAMPAIGNS
        </a>
                  </li>
                )}

                  <li
                    className={
                      props.location.pathname.includes(activeArray[25]) && "active"
                    }
                  >
                    {/* <NavLink
                      className="ol-nav-link"
                      to="/developer/my-campaigns"
                    >
                      MY CAMPAIGNS
                    </NavLink> */}
                      <a
                        href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer-assets`}
                        className="ol-nav-link"
                      >
                        DEVELOPER ASSETS
                      </a>
                  </li>
              </ul>

              <ul className="nav navbar-nav navbar-right dropdown-z-index">

                <li className="dropdown">
                  <a
                    className="ol-nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src={
                        props.partnerProfileImage
                          ? props.partnerProfileImage +
                            `?img=${new Date().getTime()}`
                          : "images/default_user.png"
                      }
                      className="img-circle"
                      width={35}
                      alt="Welcome User"
                      style={{ marginTop: "-8px" }}
                    />
                    <span className="caret" />
                  </a>
                  <ul
                    id="profile_dropdown"
                    className={`dropdown-menu dropdown-menu--profile ${
                      +props.profileCompleted === 100
                        ? "dropdown-menu--profile_complete"
                        : "dropdown-menu--profile_incomplete"
                    } `}
                  >
                    <li
                      hidden={props.profileCompleted === 100}
                      className="dropdown-menu--pie"
                    >
                      <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/edit-profile`}
                          className="ol-nav-link"
                        >
                        <div
                          className="dropdown-profile-pic"
                          style={{ display: "inline-block" }}
                        >
                          <div
                            className="percent"
                            style={{
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <AsPieProgress2 progress={props.profileCompleted} />
                          </div>
                        </div>
                        <div className="dropdown-profile-text dropdown-profile-text-m">
                          <small className="dropdown-profile-text--percent">
                            Your Profile is {props.profileCompleted}% Complete{" "}
                          </small>{" "}
                          <br />
                          <span className="text-red dropdown-menu--pie_complete-link">Complete Profile</span>
                        </div>
                      </a>
                    </li>
                    <li className="dropdown-menu--usercontent">
                        <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/edit-profile`}
                          className="ol-nav-link"
                        >
                        <div className="dropdown-profile-pic">
                          <img
                            src={
                              props.partnerProfileImage
                                ? props.partnerProfileImage +
                                  `?img=${new Date().getTime()}`
                                : "images/default_user.png"
                            }
                            className="img-circle"
                            width={35}
                            alt="Welcome User"
                          />
                        </div>
                        <div className="dropdown-profile-text dropdown-profile-text-m ">
                          <span
                            className="dropdown-profile-text-m--username"
                          >
                            {props.partnerDetails &&
                              props.partnerDetails.firstName}
                            &nbsp;
                            {props.partnerDetails &&
                              props.partnerDetails.lastName}
                          </span>
                          <br />
                          <span className="dropdown-profile-text-m--email text-light-gray text-right">
                            <small
                              style={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {props.partnerDetails &&
                                props.partnerDetails.email}
                            </small>
                          </span>
                        </div>
                      </a>
                    </li>
                    {props.partnerDetails &&
                      props.partnerDetails.isCarrier &&
                      props.partnerDetails.role === "ADMIN_BILLING" && (
                        <>
                          <li>
                              <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/billing/edit-profile/manage-users`}
                          className="ol-nav-link"
                        >
                              Manage Users
                            </a>
                          </li>
                        </>
                      )}
                    {props.partnerDetails &&
                      props.partnerDetails.isCarrier &&
                      props.partnerDetails.role === "USER_BILLING" && (
                        <>
                          <li>
                            {/* <NavLink
                              className="ol-nav-link"
                              to="/billing/edit-profile/account-details"
                              // params={{ UserBilling: "UserBilling" }}
                            > */}
                            <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/billing/edit-profile/account-details`}
                          className="ol-nav-link"
                        >
                            
                              Edit Profile
                            {/* </NavLink> */}
                            </a>
                          </li>
                        </>
                      )}
                    {props.partnerDetails && !props.partnerDetails.isCarrier && (
                      <li>
                        {/* <NavLink
                          className="ol-nav-link"
                          to="/developer/edit-profile"
                        >
                          Edit Profile
                        </NavLink> */}
                            <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/edit-profile`}
                          className="ol-nav-link"
                        >
                            
                              Edit Profile
                            {/* </NavLink> */}
                            </a>
                      </li>
                      //  </>
                    )}

                    <li>
                          <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer/change-password`}
                          className="ol-nav-link"
                        >
                            
                            Change Password
                            {/* </NavLink> */}
                            </a>
                    </li>
                    <li>
                      {/* <NavLink to="/faq">
                        Help &amp; Support
                        <br />
                      </NavLink> */}
                        <a
                          href={`${config.ANALYTICS_TO_DEVELOPER_REDIRECT_URI}/developer-assets/faqs`}
                          className="ol-nav-link"
                        >
                            
                            Help &amp; Support
                        <br />
                            {/* </NavLink> */}
                            </a>
                    </li>
                    <li role="separator" className="divider" />
                    <li>
                      <a
                        onClick={requestLogout}
                        className="text-center font-color-red cursor-pointer"
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      ) : (
        <Header />
      )}
    </>
  )
  
};

export default memo(withRouter(Navbar));
